import { useCallback, useEffect, useState } from "react";
import { fetchAdminEmployee } from "../api/adminApi";
import { fetchCompanyEmployee } from "../api/companyApi";
import type { CompanyEmployee } from "../api/types";
import { getAuthToken, getStoredAccountType } from "../auth";

export function useEmployeeDetail(employeeId: number) {
  const [employee, setEmployee] = useState<CompanyEmployee | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [usingApi, setUsingApi] = useState(false);

  const load = useCallback(async () => {
    if (!employeeId || employeeId <= 0) {
      setEmployee(null);
      return;
    }

    if (!getAuthToken()) {
      setUsingApi(false);
      setEmployee(null);
      setError("Connectez-vous pour consulter le détail assuré.");
      return;
    }

    setLoading(true);
    setError(null);
    setUsingApi(true);

    try {
      const isAdmin = getStoredAccountType() === "admin";
      const row = isAdmin
        ? await fetchAdminEmployee(employeeId)
        : await fetchCompanyEmployee(employeeId);
      setEmployee(row as CompanyEmployee);
    } catch (err) {
      const message = err instanceof Error ? err.message : "Assuré introuvable.";
      setError(message);
      setEmployee(null);
    } finally {
      setLoading(false);
    }
  }, [employeeId]);

  useEffect(() => {
    void load();
  }, [load]);

  return { employee, loading, error, usingApi, reload: load };
}

/** @deprecated Utiliser useEmployeeDetail */
export function useEnterpriseEmployeeDetail(employeeId: number) {
  return useEmployeeDetail(employeeId);
}
